import { Injectable } from '@angular/core';

import { HttpClient } from '@angular/common/http';

@Injectable({ providedIn: 'root' })
export class ConfigService {
	config: IConfig;
	isGoogleMapKeyLoaded: boolean = false;

	constructor(private _http: HttpClient) {}

	public loadConfig() {
		return new Promise<void>((resolve, reject) => {
			this._http.get('./environment.json').subscribe((config: IConfig) => {
				this.config = config;
				sessionStorage.setItem('environment', JSON.stringify(config));
				if (!this.isGoogleMapKeyLoaded) {
					const scriptEle = document.createElement('script');
					scriptEle.setAttribute('src', 'https://maps.google.com/maps/api/js?key=' + this.config.GOOGLE_MAPS_CLIENT_ID);
					document.head.appendChild(scriptEle);
					this.isGoogleMapKeyLoaded = true;
				}
				resolve();
			});

			// const config: IConfig = {
			// 	ENV: 'mock',

			// 	production: false,

			// 	apiBaseUrl: 'http://localhost:8000/api/',

			// 	tagManagerId: 'GTM-NQXMTJM',

			// 	splunkUrl:
			// 		'https://splunk-qa.boltinc.com:8088/services/collector/raw?channel=FE0ECFAD-13D5-401B-847D-77833BD77131',

			// 	splunkRTDS: 'UGO4OE5CDyXtKjNoLcrrwgieie',

			// 	TAG_MANAGER_ID: 'GTM-NQXMTJM',

			// 	ccpaLink: '',

			// 	oneTrust: '',

			// 	chatbotApi: '',

			// 	GOOGLE_MAPS_CLIENT_ID: 'AIzaSyD-9tSrke72PouQMnMX-a7eZSW0jkFMBWY',
			// };

			// this.config = config as IConfig;

			// sessionStorage.setItem('environment', JSON.stringify(config));

			// resolve();
		});
	}

	public getConfig(): IConfig {
		return this.config;
	}
}

export interface IConfig {
	ENV: string;

	production: boolean;

	apiBaseUrl: string;

	tagManagerId: string;

	splunkUrl: string;

	splunkRTDS: string;

	TAG_MANAGER_ID: string;

	ccpaLink: string;

	oneTrust: string;

	chatbotApi: string;

	GOOGLE_MAPS_CLIENT_ID: string;

	garemoval: boolean;

	quantumMetrics: string;
}
